export default __webpack_public_path__ + "static/media/GAIT SHOE.9a02f2ed.jpg";